import { useState } from "react";
import { AdminModules } from "../features";
import {
  ConfirmationDeleteModal,
  useLanguageTranslator,
} from "../../../../components";
import { useApolloQuery } from "../../../../hooks";
import { gql, useMutation } from "@apollo/client";
import { useNotify } from "../../../../components/@common/NotificationsProvider";
import { useAuthSession } from "../../../../components/AuthSessionProvider";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const GET_INSTITUTIONS_WITH_PAGINATION = gql`
  query GetInstitutionsWithPagination($page: Int!) {
    institutionsWithPagination(page: $page) {
      collection {
        id
        name
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

const DELETE_INSTITUTION = gql`
  mutation DeleteInstitution($id: ID!) {
    institutionDelete(input: { id: $id }) {
      clientMutationId
      institution {
        id
        name
      }
    }
  }
`;

function Institutions() {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isOpenDelete, setIsOpenDelete] = useState({ status: false, data: {} });

  const { translator } = useLanguageTranslator();
  const notify = useNotify();
  const navigate = useNavigate();
  const { user } = useAuthSession() as any;

  const { data, loading, refetch } = useApolloQuery({
    queryDocument: GET_INSTITUTIONS_WITH_PAGINATION,
    isPrivateCall: true,
    variables: {
      page: page,
    },
  });

  const [deleteInstitution, { loading: deleteLoading, error }] = useMutation(
    DELETE_INSTITUTION,
    {
      refetchQueries: ["GetInstitutions"],
      context: {
        headers: {
          "access-token": user?.accessToken,
          client: user?.client,
          uid: user?.email,
        },
      },
    }
  );

  const modifiedGetInstitutions =
    data?.institutionsWithPagination?.collection?.map((item: any) => {
      return {
        sr: item?.id,
        id: item?.id,
        name: item?.name,
      };
    });

  async function onClickHandler(type: string, clickedId: any) {
    if (type === "edit") {
      navigate(`/admin/institution/update?id=${clickedId}`);
      return;
    }

    if (type === "delete") {
      setIsOpenDelete({ status: true, data: { id: clickedId } });
    }
  }

  async function onClickDeleteHandler(item: any) {
    const response = await deleteInstitution({
      variables: { id: Number(item?.id) },
    });
    if (response?.data) {
      notify.success(`${translator(`Institution`)} Delete successfuly!`);
      setIsOpenDelete({ status: false, data: {} });
      setTimeout(async () => {
        await refetch();
      }, 1000);
    }
  }

  function handleDeleteClose() {
    setIsOpenDelete({ status: false, data: {} });
  }

  const tableColumns = [
    { id: "sr", label: "ID", minWidth: "100%", align: "left" },
    {
      id: "name",
      label: translator("dashboardTableHead.Name"),
      minWidth: "100%",
      align: "left",
    },
    {
      id: "id",
      label: translator("dashboardTableHead.Action"),
      minWidth: "100%",
      align: "right",
    },
  ];

  return (
    <>
      <ConfirmationDeleteModal
        isOpen={isOpenDelete?.status}
        item={isOpenDelete?.data}
        onClickHandler={onClickDeleteHandler}
        handleClose={handleDeleteClose}
      />
      <AdminModules
        title={translator(`Institutions`)}
        path="/admin/institutions/add-new"
        isAccounts={true}
        tableColumns={tableColumns}
        data={modifiedGetInstitutions}
        moduleKey="institution-module"
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        onClickHandler={onClickHandler}
        metadata={data?.institutionsWithPagination?.metadata}
      />
    </>
  );
}

export { Institutions };
